/*
 * Purpose: Floating control to switch Surface vs Routines (autoblocks.ai) design styles
 * Last modified: 2026-06-27 | Agent
 * Completeness: 92
 */
import { Layers, Palette } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDesignStyle } from "@/components/design-style-provider";
import { designStyleLabels } from "@/lib/design-tokens/routines";
import { ModeToggle } from "@/components/theme-toggle";

export function DesignStyleToggle() {
  const { designStyle, setDesignStyle } = useDesignStyle();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2">
      <ModeToggle />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="h-9 gap-1.5 bg-background/95 backdrop-blur-sm shadow-md"
          >
            {designStyle === "routines" ? (
              <Layers className="h-4 w-4" />
            ) : (
              <Palette className="h-4 w-4" />
            )}
            <span className="hidden sm:inline text-xs font-medium">
              {designStyleLabels[designStyle]}
            </span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuLabel className="text-xs text-muted-foreground">
            Design style
          </DropdownMenuLabel>
          <DropdownMenuItem
            onClick={() => setDesignStyle("surface")}
            className={designStyle === "surface" ? "bg-accent" : undefined}
          >
            <Palette className="mr-2 h-4 w-4" />
            Surface — warm planes
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => setDesignStyle("routines")}
            className={designStyle === "routines" ? "bg-accent" : undefined}
          >
            <Layers className="mr-2 h-4 w-4" />
            Routines — autoblocks.ai
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
